import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../utill/validation";
import { Row, Space } from "antd";
import axios from "axios";
import api from "../../config.json";
import Table from "../../Common/table";
import dateTime from "../../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../utill/Excelimport";
import Loading from "../../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import HighSpeedString from "../../utill/HighSpeedinputstring";
import PaginationComponent from "../../Common/PaginationComponent";
import BasicTabs from "../../utill/TabsComponent";

const GenerateSticker = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [Data, setData] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [qrCodeStr, setQrCodeStr] = useState("");
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(0);
  const [PageSize, setPageSize] = useState(50);
  const [TabValue, setTabValue] = useState(0);

  console.log(TabValue, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Enable' values
    const updatedList = componentList.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setcomponentList(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };
  useEffect(() => {
    getComponentCodeData();
  }, [CurrentPage, PageSize]);

  const getCompoundMaster = () => {
    axios
      .get(api.api + "compoundMaster")
      .then((result) => {
        console.log(result.data, "compound data");
        const list = result.data.map((one) => ({
          Name: one.CompoundCode,
          value: one.CompoundCode,
        }));

        setTemplateList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      key: "select",
      label: <input type="checkbox" onChange={handelSelectAll} />,
      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["Enable"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },

    { path: "CompoundCode", label: "Compound Code" },
    { path: "BatchCode", label: "Batch Code" },
    { path: "TracebilityNo", label: "Traceability No" },
    { path: "Tc_No", label: "Test Certificate No" },

    {
      path: "MixingDate",
      label: "Mixing Date",
      content: (obj) => (
        <label>{moment(obj.MixingDate).format("DD-MM-YY")}</label>
      ),
    },
    {
      path: "ExpiryDate",
      label: "Expiry Date",
      content: (obj) => (
        <label>{moment(obj.ExpiryDate).format("DD-MM-YY")}</label>
      ),
    },

    { path: "Qty", label: "Qty (kg)" },
    { path: "NumOfStickers", label: "Num Of Stickers" },
    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "view",
      content: (user) => (
        <button
          // disabled={
          //   !getRightsForAccess("StaticDataRights", RightName, "update")
          // }
          onClick={() => {
            // setInputData(user)
            console.log(user, "dshvgvbskbvksjb");
            setUpdate(user);
            setopStatus("view");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    // { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }
  ];

  useEffect(() => {
    if (opStatus == "view") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {
    Heading("Generate Traceability Sticker");
    getCompoundMaster();
  }, []);

  const getComponentCodeData = () => {
    // axios
    //   .get(api.api + "compoundCode")
    //   .then((result) => {

    //     setcomponentList(result.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    setLoader(true);
    axios
      .put(api.api + "compoundCode", {
        query: "",
        PageSize: PageSize,
        Page: CurrentPage,
      })
      .then((result) => {
        setLoader(false);
        console.log(result.data.result, "jjkfhshf");
        setcomponentList(result.data.data);
        setTotalPage(result.data.totalDocuments);
        console.log(result.data, "-----------------");
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //   for (let i = 0; i < qrCodeGroups.length; i++) {
  //     const page = document.getElementsByClassName('a4-page')[i];
  //     const canvas = await html2canvas(page);
  //     const imgData = canvas.toDataURL('image/png');
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     if (i < qrCodeGroups.length - 1) pdf.addPage();
  //   }
  //   pdf.save(`${Inputdata.CompoundCode+'_' + Inputdata.BatchCode + '_'+Inputdata.NumOfStickers}.pdf`);
  // };
  // const A4Sheet = ( QRCodeVisible, Inputdata, rows = 3, cols = 3 ) => {
  //   // Split the QR codes into groups of 4
  //   const qrCodeGroups = [];
  //   const NumberOfStickerOnPage = 6;
  //   if (QRCodeVisible) {
  //     const totalStickers = Number(Inputdata.NumOfStickers);
  //     for (let i = 0; i < totalStickers; i += NumberOfStickerOnPage) {
  //       qrCodeGroups.push([...Array(Math.min(NumberOfStickerOnPage, totalStickers - i))].map((_, j) => i + j));
  //     }
  //   }

  //   // Function to download the PDF
  //   const downloadPDF = (qrCodeGroups, Inputdata) => {
  //     const doc = new jsPDF();
  //     const QrCode = `CC:${Inputdata.CompoundCode};BN:${Inputdata.BatchCode};TC:${Inputdata.TracebilityNo};MD:${Inputdata.MixingDate};ED:${Inputdata.ExpiryDate};QT:${Inputdata.Qty}`;

  //     qrCodeGroups.forEach((group, pageIndex) => {
  //       if (pageIndex > 0) {
  //         doc.addPage(); // Add a new page for every group after the first
  //       }

  //       group.forEach((index, groupIndex) => {
  //         const x = 10 + (groupIndex % 2) * 100; // Position horizontally
  //         const y = 10 + Math.floor(groupIndex / 2) * 60; // Position vertically
  //         // Adding QR code
  //         doc.addImage(QrCode, 'PNG', x, y, 50, 50);

  //         // Adding text below the QR code
  //         const textY = y + 55; // Space below QR code for text
  //         doc.setFontSize(12);
  //         doc.text(Inputdata.CompoundCode, x, textY);
  //         doc.text(Inputdata.BatchCode, x, textY + 10);
  //         doc.text(`${index + 1} / ${Inputdata.NumOfStickers}`, x, textY + 20);
  //       });
  //     });

  //     doc.save('qr-codes.pdf'); // Trigger PDF download
  //   };

  //   const QrCode = `CC:${Inputdata.CompoundCode};BN:${Inputdata.BatchCode};TC:${Inputdata.TracebilityNo};MD${Inputdata.MixingDate};ED:${Inputdata.ExpiryDate};QT:${Inputdata.Qty}`;

  //   return (
  //     <div>
  //       <Button type="primary" onClick={() => { downloadPDF(qrCodeGroups, Inputdata); }} style={{ marginBottom: '16px' }}>
  //         Download as PDF
  //       </Button>
  //       <div className="a4-sheet-scrollable">
  //         {qrCodeGroups.map((group, pageIndex) => (
  //           <div className="a4-page" key={pageIndex} style={{ pageBreakAfter: 'always' }}>
  //             {group.map(index => (
  //               <div className="d-flex justify-content-center" key={index}>
  //                 <div className='p-5'>
  //                   <QRCodeSVG className='d-flex justify-content-center my-3' value={QrCode} size={100} />
  //                   <h6 className="bolder text-center">{Inputdata.CompoundCode}</h6>
  //                   <h6 className="bolder text-center">{Inputdata.BatchCode}</h6>
  //                   <h6 className="bolder text-center">{index + 1 + ' / ' + Inputdata.NumOfStickers}</h6>
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // };
  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(`TraceabilitySticker.pdf`);

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(Inputdata.NumOfStickers);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }
    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = JSON.stringify({
      CC: Inputdata.CompoundCode,
      BN: Inputdata.BatchCode,
      TC: Inputdata.TracebilityNo,
      MD: moment(Inputdata.MixingDate).format("DD-MM-YY"),
      ED: moment(Inputdata.ExpiryDate).format("DD-MM-YY"),
      QT: Inputdata.Qty,
    });

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${Math.sqrt(16)}, 1fr)`, // 3 columns in each row
                  gridTemplateRows: `repeat(${Math.sqrt(16)}, auto)`, // 3 rows per page (auto height)
                  gap: "57px", // Optional: Adjust the gap between items as needed
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                {group.map((one, index) => (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center "
                    key={index}
                    style={{ textAlign: "center", marginBottom: "10px" }}
                  >
                    <QRCodeSVG
                      value={QrCode}
                      level={"M"}
                      size={80}
                      style={{ marginBottom: "3px" }}
                    />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{
                        fontSize: "9px",
                        color: "black",
                        letterSpacing: "0.5px",
                        lineHeight: "1.2",
                      }}
                      className="bolder p-0 m-0"
                    >
                      {Inputdata.CompoundCode}
                      <br />
                      {Inputdata.BatchCode}
                      <br />

                      {`${index + 1} / ${Inputdata.NumOfStickers}`}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(
        componentList,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setcomponentList(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    BatchCode: joi.string().required(),
    CompoundCode: joi.string().required(),
    TracebilityNo: joi.string().required(),
    Tc_No: joi.string().required(),
    MixingDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfStickers: joi.number().required(),
    Dispatch: joi.string().optional(),
    WithoutQR: joi.boolean().optional(),
    _id: joi.string(),
  };

  // const handleOnChange = (e) => {
  //   const { name, value } = e.currentTarget;

  //   setInputData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
    if (name === "Dispatch" && value == "") {
      console.log(name, value == "", "Input Data Received");

      setInputData({});
      return;
    }
    try {
      const obj = { ...Inputdata };

      let JsonData = null;

      // Try parsing the value as JSON
      try {
        JsonData = JSON.parse(value);
      } catch (error) {
        console.log("Please Scan Valid Qr Code");
      }
      console.log(name, value, "vdfiubdiufhdfjk", JsonData);

      if (JsonData && typeof JsonData == "object" && JsonData.UID) {
        const UniqueID = JsonData.UID;
        if (JsonData.Batch && JsonData.CompoundCode) {
          obj["BatchCode"] = JsonData.Batch;
          obj["CompoundCode"] = JsonData.CompoundCode;
          obj["MixingDate"] = JsonData.MfgDate;
          obj["ExpiryDate"] = JsonData.ExpiryDate;
          obj["NumOfStickers"] = "1";
          obj["Dispatch"] = JsonData.UID;

          console.log("Valid Compound Code scanned:", obj, UniqueID);
        } else {
          console.log(`Please scan the correct ${name}`);
        }
      } else {
        if (name == "Quality") {
          obj[name] = parseFloat(value);
        } else {
          obj[name] = value;
        }
        // Handle non-JSON or plain string values
        console.log(`Non-JSON value or invalid UID: ${value}`);
      }

      setInputData(obj);
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };
  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundCode/" + data._id, { data: data })
          .then((result) => {
            getComponentCodeData();
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data) => {
    console.log(data, "cvosjnvjnv");
    const checksheet = { ...data };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    const errors = validation.validate(checksheet, schema);
    if (errors) {
      seterrors(errors);
      return;
    }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "compoundCode/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getComponentCodeData();
          setQRCodeVisible(true);

           handleCloseModel()
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "compoundCode", checksheet)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(Inputdata.NumOfStickers);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
            handleCloseModel()
          // }
          getComponentCodeData();

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  console.log(Inputdata, "vdfkjvbkdfb");
  const downloadPDFforAll = (data) => {
    const pdf = [];
    console.log(data, "fsfsdfsdfsdf");
    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(one.NumOfStickers))].forEach((_, j) => {
          pdf.push({
            QrCode: JSON.stringify({
              CC: one.CompoundCode,
              BN: one.BatchCode,
              TC: one.TracebilityNo,
              MD: moment(one.MixingDate).format("DD-MM-YY"),
              ED: moment(one.ExpiryDate).format("DD-MM-YY"),
              QT: one.Qty,
            }),
            index: j,
            BatchCode: one.BatchCode,
            CompoundCode: one.CompoundCode,
            TracebilityNo: one.TracebilityNo,

            NumOfStickers: one.NumOfStickers,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Generate Traceability QR
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {
          opStatus == "view" ? <Row>
          {opStatus !== "view" && (
            <Col sm={12}>
              <div className="form-group form-group-sm">
                {/* <label htmlFor="operationRejectionCost">Dispatch QR Code</label> */}
                <HighSpeedString
                  value={qrCodeStr}
                  onClear={() => {
                    setInputData({});
                  }}
                  field={{ FieldName: "Dispatch QR Code" }}
                  getString={(string) => {
                    if (string) {
                      setQrCodeStr(string);
                      handleOnChange({
                        currentTarget: {
                          name: "Dispatch",
                          value: string,
                        },
                      });
                      //  setTimeout(() => {
                      console.log(string, "fkwskfbwehkfbk");
                      //
                      //  }, 9000);
                    }
                    //  handelRedirect(string)
                  }}
                />
                {/* <input
             required
             // disabled={true}
             onChange={handleOnChange}
             style={{ width: "100%" ,backgroundColor: "#FCEF91"}}
             //disabled={cycleTimeRadioState === 1 ? false : true}
             className="form-control form-control-sm"
             type="text"
             // min="0"
             placeholder="Scan Dispatch QR Code"
             name="Dispatch"
             value={Inputdata.Dispatch}
           /> */}
                {errors.Dispatch && (
                  <div className="alert small alert-danger">
                    {errors["Dispatch"]}
                  </div>
                )}
              </div>
            </Col>
          )}
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">Batch Code</label>
              <input
                required
                disabled={true}
                onChange={handleOnChange}
                style={{ width: "100%" }}
                //disabled={cycleTimeRadioState === 1 ? false : true}
                className="form-control form-control-sm"
                type="text"
                // min="0"
                placeholder="Batch Code"
                name="BatchCode"
                value={Inputdata.BatchCode || ""}
              />
              {errors.BatchCode && (
                <div className="alert small alert-danger">
                  {errors["BatchCode"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group mt-2">
              <label htmlFor="operationRejectionCost">
                Compound Code
              </label>
              <AntdSelect
                disabled={true}
                placeholder="Check Compound Code."
                onChange={(value) => {
                  const template = templateList.find(
                    (x) => x.Name == value
                  );
                  setSelectedTemplate(template || {});
                  handleOnChange({
                    currentTarget: { name: "CompoundCode", value: value },
                  });
                }}
                value={Inputdata.CompoundCode || []}
                style={{ width: "100%" }}
              >
                {templateList.map((one) => {
                  return (
                    <AntdSelect.Option value={one.Name}>
                      {one.Name}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
              {errors.CompoundCode && (
                <div className="alert small alert-danger">
                  {errors["CompoundCode"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">
                Traceability No
              </label>
              <input
                required
                onChange={handleOnChange}
                style={{ width: "100%", backgroundColor: "#FCEF91" }}
                placeholder="Traceability No"
                disabled={opStatus == "view" ? true : false}
                className="form-control form-control-sm"
                type="text"
                // min="0"
                name="TracebilityNo"
                value={Inputdata.TracebilityNo}
              />
              {errors.TracebilityNo && (
                <div className="alert small alert-danger">
                  {errors["TracebilityNo"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">
                Test Certificate No
              </label>
              <input
                required
                onChange={handleOnChange}
                style={{ width: "100%", backgroundColor: "#FCEF91" }}
                placeholder="Test Certificate No"
                disabled={opStatus == "view" ? true : false}
                className="form-control form-control-sm"
                type="text"
                // min="0"
                name="Tc_No"
                value={Inputdata.Tc_No}
              />
              {errors.Tc_No && (
                <div className="alert small alert-danger">
                  {errors["Tc_No"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">Mixing Date</label>
              <input
                required
                onChange={handleOnChange}
                disabled={true}
                placeholder="Mixing Date"
                className="form-control form-control-sm"
                type="date"
                name="MixingDate"
                value={
                  (Inputdata.MixingDate &&
                    Inputdata.MixingDate.split("T")[0]) ||
                  ""
                }
              />
              {errors.MixingDate && (
                <div className="alert small alert-danger">
                  {errors["MixingDate"]}
                </div>
              )}
            </div>
          </Col>{" "}
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">Use by</label>
              <input
                required
                disabled={true}
                placeholder="Use by"
                onChange={handleOnChange}
                className="form-control form-control-sm"
                type="date"
                name="ExpiryDate"
                value={
                  (Inputdata.ExpiryDate &&
                    Inputdata.ExpiryDate.split("T")[0]) ||
                  ""
                } // ensure value is a valid date string or empty
              />
              {console.log(Inputdata.ExpiryDate, "ojgnjon")}
              {errors.ExpiryDate && (
                <div className="alert small alert-danger">
                  {errors["ExpiryDate"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">Qty (kg)</label>
              <input
                required
                onChange={handleOnChange}
                disabled={opStatus == "view" ? true : false}
                style={{ backgroundColor: "#FCEF91" }}
                placeholder="Qty"
                className="form-control form-control-sm"
                type="number"
                name="Qty"
                value={Inputdata.Qty}
              />
              {errors.Qty && (
                <div className="alert small alert-danger">
                  {errors["Qty"]}
                </div>
              )}
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group form-group-sm">
              <label htmlFor="operationRejectionCost">
                Number Of Sticker
              </label>
              <input
                required
                onChange={handleOnChange}
                disabled={opStatus == "view" ? true : false}
                className="form-control form-control-sm"
                placeholder="Number Of Sticker"
                type="number"
                name="NumOfStickers"
                max={100}
                value={Inputdata.NumOfStickers}
              />
              {errors.NumOfStickers && (
                <div className="alert small alert-danger">
                  {errors["NumOfStickers"]}
                </div>
              )}
            </div>
          </Col>
        </Row> : <BasicTabs
            setTabValue={(data) => {
              setTabValue(data);
              if (data == 1) {
                // const inputdata = { ...Inputdata };
                // inputdata["WithoutQR"] = true;
                setInputData({WithoutQR:true});
              } else {
                // const inputdata = { ...Inputdata };
                // inputdata["WithoutQR"] = false;
                setInputData({WithoutQR:false});

              }
            }}
            Tab1={
              <Row>
                {opStatus !== "view" && (
                  <Col sm={12}>
                    <div className="form-group form-group-sm">
                      {/* <label htmlFor="operationRejectionCost">Dispatch QR Code</label> */}
                      <HighSpeedString
                        value={qrCodeStr}
                        onClear={() => {
                          setInputData({});
                        }}
                        field={{ FieldName: "Dispatch QR Code" }}
                        getString={(string) => {
                          if (string) {
                            setQrCodeStr(string);
                            handleOnChange({
                              currentTarget: {
                                name: "Dispatch",
                                value: string,
                              },
                            });
                            //  setTimeout(() => {
                            console.log(string, "fkwskfbwehkfbk");
                            //
                            //  }, 9000);
                          }
                          //  handelRedirect(string)
                        }}
                      />
                      {/* <input
                   required
                   // disabled={true}
                   onChange={handleOnChange}
                   style={{ width: "100%" ,backgroundColor: "#FCEF91"}}
                   //disabled={cycleTimeRadioState === 1 ? false : true}
                   className="form-control form-control-sm"
                   type="text"
                   // min="0"
                   placeholder="Scan Dispatch QR Code"
                   name="Dispatch"
                   value={Inputdata.Dispatch}
                 /> */}
                      {errors.Dispatch && (
                        <div className="alert small alert-danger">
                          {errors["Dispatch"]}
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Batch Code</label>
                    <input
                      required
                      disabled={true}
                      onChange={handleOnChange}
                      style={{ width: "100%" }}
                      //disabled={cycleTimeRadioState === 1 ? false : true}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      placeholder="Batch Code"
                      name="BatchCode"
                      value={Inputdata.BatchCode || ""}
                    />
                    {errors.BatchCode && (
                      <div className="alert small alert-danger">
                        {errors["BatchCode"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group mt-2">
                    <label htmlFor="operationRejectionCost">
                      Compound Code
                    </label>
                    <AntdSelect
                      disabled={true}
                      placeholder="Check Compound Code."
                      onChange={(value) => {
                        const template = templateList.find(
                          (x) => x.Name == value
                        );
                        setSelectedTemplate(template || {});
                        handleOnChange({
                          currentTarget: { name: "CompoundCode", value: value },
                        });
                      }}
                      value={Inputdata.CompoundCode || []}
                      style={{ width: "100%" }}
                    >
                      {templateList.map((one) => {
                        return (
                          <AntdSelect.Option value={one.Name}>
                            {one.Name}
                          </AntdSelect.Option>
                        );
                      })}
                    </AntdSelect>
                    {errors.CompoundCode && (
                      <div className="alert small alert-danger">
                        {errors["CompoundCode"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Traceability No
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      style={{ width: "100%", backgroundColor: "#FCEF91" }}
                      placeholder="Traceability No"
                      disabled={opStatus == "view" ? true : false}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      name="TracebilityNo"
                      value={Inputdata.TracebilityNo}
                    />
                    {errors.TracebilityNo && (
                      <div className="alert small alert-danger">
                        {errors["TracebilityNo"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Test Certificate No
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      style={{ width: "100%", backgroundColor: "#FCEF91" }}
                      placeholder="Test Certificate No"
                      disabled={opStatus == "view" ? true : false}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      name="Tc_No"
                      value={Inputdata.Tc_No}
                    />
                    {errors.Tc_No && (
                      <div className="alert small alert-danger">
                        {errors["Tc_No"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Mixing Date</label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={true}
                      placeholder="Mixing Date"
                      className="form-control form-control-sm"
                      type="date"
                      name="MixingDate"
                      value={
                        (Inputdata.MixingDate &&
                          Inputdata.MixingDate.split("T")[0]) ||
                        ""
                      }
                    />
                    {errors.MixingDate && (
                      <div className="alert small alert-danger">
                        {errors["MixingDate"]}
                      </div>
                    )}
                  </div>
                </Col>{" "}
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Use by</label>
                    <input
                      required
                      disabled={true}
                      placeholder="Use by"
                      onChange={handleOnChange}
                      className="form-control form-control-sm"
                      type="date"
                      name="ExpiryDate"
                      value={
                        (Inputdata.ExpiryDate &&
                          Inputdata.ExpiryDate.split("T")[0]) ||
                        ""
                      } // ensure value is a valid date string or empty
                    />
                    {console.log(Inputdata.ExpiryDate, "ojgnjon")}
                    {errors.ExpiryDate && (
                      <div className="alert small alert-danger">
                        {errors["ExpiryDate"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Qty (kg)</label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={opStatus == "view" ? true : false}
                      style={{ backgroundColor: "#FCEF91" }}
                      placeholder="Qty"
                      className="form-control form-control-sm"
                      type="number"
                      name="Qty"
                      value={Inputdata.Qty}
                    />
                    {errors.Qty && (
                      <div className="alert small alert-danger">
                        {errors["Qty"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Number Of Sticker
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={opStatus == "view" ? true : false}
                      className="form-control form-control-sm"
                      placeholder="Number Of Sticker"
                      type="number"
                      name="NumOfStickers"
                      max={100}
                      value={Inputdata.NumOfStickers}
                    />
                    {errors.NumOfStickers && (
                      <div className="alert small alert-danger">
                        {errors["NumOfStickers"]}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            }
            Tab2={
              <Row>
                <Col sm={12}>
                <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Batch Code</label>
                    <input
                      required
                      // disabled={true}
                      onChange={handleOnChange}
                      style={{ width: "100%" }}
                      //disabled={cycleTimeRadioState === 1 ? false : true}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      placeholder="Batch Code"
                      name="BatchCode"
                      value={Inputdata.BatchCode || ""}
                    />
                    {errors.BatchCode && (
                      <div className="alert small alert-danger">
                        {errors["BatchCode"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group mt-2">
                    <label htmlFor="operationRejectionCost">
                      Compound Code
                    </label>
                    <AntdSelect
                      showSearch // Enables search functionality
                      disabled={opStatus === "view"}
                      placeholder="Check Compound Code."
                      onChange={(value) => {
                        const template = templateList.find(
                          (x) => x.Name === value
                        );
                        setSelectedTemplate(template || {});
                        handleOnChange({
                          currentTarget: { name: "CompoundCode", value: value },
                        });
                      }}
                      value={Inputdata.CompoundCode || []}
                      style={{ width: "100%" }}
                      optionFilterProp="children" // Ensures search is based on the option's text
                    >
                      {templateList.map((one) => (
                        <AntdSelect.Option key={one.Name} value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      ))}
                    </AntdSelect>

                    {errors.CompoundCode && (
                      <div className="alert small alert-danger">
                        {errors["CompoundCode"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Tracebility No
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      style={{ width: "100%" }}
                      placeholder="Tracebility No"
                      disabled={opStatus === "view" ? true : false}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      name="TracebilityNo"
                      value={Inputdata.TracebilityNo}
                    />
                    {errors.TracebilityNo && (
                      <div className="alert small alert-danger">
                        {errors["TracebilityNo"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Test Certificate No
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      style={{ width: "100%" }}
                      placeholder="Test Certificate No"
                      disabled={opStatus == "view" ? true : false}
                      className="form-control form-control-sm"
                      type="text"
                      // min="0"
                      name="Tc_No"
                      value={Inputdata.Tc_No}
                    />
                    {errors.Tc_No && (
                      <div className="alert small alert-danger">
                        {errors["Tc_No"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Mixing Date</label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={opStatus === "view" ? true : false}
                      placeholder="Mixing Date"
                      className="form-control form-control-sm"
                      type="date"
                      name="MixingDate"
                      value={
                        (Inputdata.MixingDate &&
                          Inputdata.MixingDate.split("T")[0]) ||
                        ""
                      }
                    />
                    {errors.MixingDate && (
                      <div className="alert small alert-danger">
                        {errors["MixingDate"]}
                      </div>
                    )}
                  </div>
                </Col>{" "}
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Expiry Date</label>
                    <input
                      required
                      disabled={opStatus === "view" ? true : false}
                      placeholder="Expiry Date"
                      onChange={handleOnChange}
                      className="form-control form-control-sm"
                      type="date"
                      name="ExpiryDate"
                      value={
                        (Inputdata.ExpiryDate &&
                          Inputdata.ExpiryDate.split("T")[0]) ||
                        ""
                      } // ensure value is a valid date string or empty
                    />
                    {console.log(Inputdata.ExpiryDate, "ojgnjon")}
                    {errors.ExpiryDate && (
                      <div className="alert small alert-danger">
                        {errors["ExpiryDate"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">Qty (kg)</label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={opStatus === "view" ? true : false}
                      placeholder="Qty"
                      className="form-control form-control-sm"
                      type="number"
                      name="Qty"
                      value={Inputdata.Qty}
                    />
                    {errors.Qty && (
                      <div className="alert small alert-danger">
                        {errors["Qty"]}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group form-group-sm">
                    <label htmlFor="operationRejectionCost">
                      Number Of Sticker
                    </label>
                    <input
                      required
                      onChange={handleOnChange}
                      disabled={opStatus === "view" ? true : false}
                      className="form-control form-control-sm"
                      placeholder="Number Of Sticker"
                      type="number"
                      name="NumOfStickers"
                      max={100}
                      value={Inputdata.NumOfStickers}
                    />
                    {errors.NumOfStickers && (
                      <div className="alert small alert-danger">
                        {errors["NumOfStickers"]}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            }
          />
        }
          
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {/* <button style={{}} className='btn btn-sm btn-primary' onClick={() => {
           
           handelSaveData(Inputdata);
         
       }} >
         Submit
       </button> */}
          {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeVisible && A4Sheet(QRCodeVisible, Inputdata, 3, 3)
              // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                const error = validateCheckCheckPoints(rows);
                if (error.IsError) {
                  swal("ERROR", error.message.join(", "), { dangerMode: true });
                } else {
                  handelSaveData(Inputdata);
                }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Generate Traceability Sticker
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>
                  <div
                    style={{ overflowY: "scroll", height: "72vh" }}
                    className=""
                  >
                    {QRCodeArray.map((group, index) => (
                      <div className="a4-sheet-scrollable">
                        <div
                          className="a4-page"
                          // key={pageIndex}
                          style={{ pageBreakAfter: "always" }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${Math.sqrt(
                                16
                              )}, 1fr)`, // 3 columns in each row
                              gridTemplateRows: `repeat(${Math.sqrt(
                                16
                              )}, auto)`, // 3 rows per page (auto height)
                              gap: "57px", // Optional: Adjust the gap between items as needed
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            {group.map((one, index) => (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center "
                                key={index}
                                style={{
                                  textAlign: "center",
                                  marginBottom: "10px",
                                }}
                              >
                                <QRCodeSVG
                                  value={one.QrCode}
                                  level={"M"}
                                  size={80}
                                  style={{ marginBottom: "3px" }}
                                />{" "}
                                {/* Adjust the size of the QR code */}
                                <p
                                  style={{
                                    fontSize: "9px",
                                    color: "black",
                                    letterSpacing: "0.5px",
                                    lineHeight: "1.2",
                                  }}
                                  className="bolder p-0 m-0"
                                >
                                  {one.CompoundCode}
                                  <br />
                                  {one.BatchCode}
                                  <br />

                                  {`${1 + one.index} / ${one.NumOfStickers}`}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
              // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport />} */}
      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Download PDFs
        </button>
      )}
      {
        <button
          disabled={
            !getRightsForAccess("DynamicDataRights", RightName, "write")
          }
          className="btn-sm btn-success mx-2"
          onClick={() => {
            setQRCodeVisible(false);
            setmodelState(true);
            setInputData({});
            setUpdate({});
            setSelectedTemplate({});
          }}
        >
          Create Traceability Sticker
        </button>
      }
      {componentList.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={componentList}
        />
      )}
      {componentList.length > 0 && (
        <div className="float-end m-3">
          <PaginationComponent
            defaultCurrent={CurrentPage}
            total={TotalPage}
            CurrentPageNumber={(currentpage, pagesize) => {
              setCurrentPage(currentpage);
              setPageSize(pagesize);
            }}
          />
        </div>
      )}
    </>
  );
};

export default GenerateSticker;
